<template>
  <div>
    <list
      row-key="RecordId"
      ref="list"
      unit="对账信息"
      :page="page"
      :query-params="params"
      :show-checkbox="$permission.canDel()"
      :show-query="showQuery"
      :get-data-func="api.reconcileList"
      @on-reset="onResetQuery"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="订单日期">
          <range-picker
            ref="picker"
            @change="
              (x) => {
                params.DocDateStart = x.Start;
                params.DocDateEnd = x.End;
              }
            "
          />
        </el-form-item>
        <el-form-item label="商家名称"
             v-if="loginInfo.UserType == 0">
          <el-input
            v-model="params.BusiName"
            placeholder="请输入商家名称"
            clearable
          />
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="BusiName" label="商家全称"  v-if="loginInfo.UserType == 0"/>
        <el-table-column prop="Amount" label="金额" />
        <el-table-column prop="Rate" label="微信支付手续费" />
        <el-table-column prop="PlatformAmount" label="平台分佣" />
        <el-table-column prop="BusinessAmount" label="商家收益" />

        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/shop/business").default,
      loginInfo: JSON.parse(localStorage.getItem("loginInfo")),

      params: {
        BusiName: "",
        DocDateStart: null,
        DocDateEnd: null,
      },
    };
  },
  beforeMount() {},
  mounted() {},
  methods: {
    onResetQuery() {
      if (this.$refs.picker) this.$refs.picker.clear();
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
    onExport() {
      this.api.reconcileExport(this.params);
    },
  },
};
</script>
